import React, { useState } from "react";
import "./accordion.css";
import { useDispatch, useSelector } from "react-redux";
import { updateDesignParameter } from "../../../../Features/designParameter";
import { addObstacleNode, removeObstacleNode } from "./accordionFunction";

export default function ObstacleLines({ points, index }) {
  const [tooltip, setTooltip] = useState();
  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const designParameter = useSelector((state) => state.designParameter);

  const abstacles = roofInfo?.value?.abstacles || [];
  let updatePoints =
    abstacles.length > 0 && index <= abstacles.length - 1
      ? abstacles[index].updatedPoints
      : points;

  const polygonIndex = index;

  return updatePoints.map((item, i) => (
    <div
      className="ac-lines"
      key={i}
      onClick={() => dispatch(updateDesignParameter({ lineNo: i }))}
    >
      <div className="ac-title">
        <img src="../images/icons/lineIcon.svg" alt="roofIcon" className="lineIcon"></img>
        <span style={{ color: designParameter.lineNo === i ? "green" : "" }}>
          Line {i + 1}
        </span>
      </div>
      <div className="ac-action">
        <div
          className="actionBtn"
          onClick={() =>
            addObstacleNode({
              i,
              dispatch,
              quantityInfo,
              polygonIndex,
              abstacles,
              updatePoints,
            })
          }
        >
          {tooltip === `add${i}` && (
            <h4 className="warning">
              <div className="sideArrow"></div>
              Add Node
            </h4>
          )}
          <i
            className="bi bi-circle-fill"
            onMouseEnter={() => setTooltip(`add${i}`)}
            onMouseLeave={() => setTooltip()}
          ></i>
        </div>
        <div
          className="actionBtn"
          onClick={() =>
            removeObstacleNode({
              i,
              dispatch,
              updatePoints,
              abstacles,
              polygonIndex,
            })
          }
        >
          {tooltip === `delete${i}` && (
            <h4 className="warning">
              <div className="sideArrow"></div>
              Delete Line
            </h4>
          )}
          <i
            className="bi bi-trash-fill trashIcon"
            onMouseEnter={() => setTooltip(`delete${i}`)}
            onMouseLeave={() => setTooltip()}
          ></i>
        </div>
      </div>
    </div>
  ));
}
